import React, { useState, useEffect } from 'react';

const PasswordProtection = ({ onUnlock, postId }) => {
  // Use an array to track emojis instead of a string
  const [passwordEmojis, setPasswordEmojis] = useState([]);
  const [error, setError] = useState('');
  const [showHint, setShowHint] = useState(false);
  
  // Password configuration - can be customized per post but LOL IT AIN'T STOPPIN CRAP xD Just for looks :P Hi :D Glad you're here! <3
  const passwordConfig = {
    'engine-vp-vision': {
      correctPassword: ['👍', '👍', '👏'],
      hint: 'Thumbs Up, Thumbs Up, Clap'
    },
    // Default password for any protected content
    default: {
      correctPassword: ['👍', '👍', '👏'],
      hint: 'Thumbs Up, Thumbs Up, Clap'
    }
  };
  
  // Get the correct config for this post
  const config = passwordConfig[postId] || passwordConfig.default;

  // Emoji keyboard options
  const emojiOptions = [
    '👍', '👏', '🔒', '🔑', '🚀', '💡', '🔍', '💼', 
    '📊', '💰', '📈', '🤝', '🌟', '👀', '🎯', '💪'
  ];
  
  const handleEmojiClick = (emoji) => {
    if (passwordEmojis.length < 3) {
      setPasswordEmojis(prev => [...prev, emoji]);
      setError(''); // Clear any previous errors
    }
  };
  
  const handleBackspace = () => {
    setPasswordEmojis(prev => prev.slice(0, -1));
  };
  
  const handleSubmit = () => {
    // Check if arrays match
    const correct = config.correctPassword;
    const current = passwordEmojis;
    
    if (current.length === correct.length && 
        current.every((val, index) => val === correct[index])) {
      onUnlock();
    } else {
      setError('Incorrect password. Try again!');
      setPasswordEmojis([]);
    }
  };
  
  const handleClear = () => {
    setPasswordEmojis([]);
    setError('');
  };

  return (
    <div className="flex items-center justify-center h-full min-h-[60vh]">
      <div className="bg-gray-900 rounded-lg p-6 max-w-md w-full text-center">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-white mb-2">
            🔐 Password Protected
          </h2>
          <p className="text-gray-300 mb-4">
            Enter 3 emojis to unlock this content
          </p>
          
          {/* Password Display */}
          <div className="bg-gray-800 rounded-lg p-4 mb-6 min-h-[60px] flex flex-col items-center justify-center">
            <div className="text-3xl">
              {passwordEmojis.length > 0 ? 
                passwordEmojis.join('') : 
                <span className="text-gray-500">Enter emoji password</span>
              }
            </div>
            <div className="mt-2 text-xs text-gray-400">
              {passwordEmojis.length}/3 emojis entered
            </div>
          </div>
        </div>
        
        {/* Emoji Keyboard */}
        <div className="grid grid-cols-4 gap-3 mb-6">
          {emojiOptions.map(emoji => (
            <button
              key={emoji}
              onClick={() => handleEmojiClick(emoji)}
              className="bg-gray-800 hover:bg-gray-700 text-2xl rounded-lg p-2 transition-colors"
              disabled={passwordEmojis.length >= 3}
            >
              {emoji}
            </button>
          ))}
        </div>
        
        {/* Actions */}
        <div className="flex space-x-3 mb-4">
          <button
            onClick={handleBackspace}
            className="flex-1 bg-gray-700 hover:bg-gray-600 text-white py-2 rounded-md transition-colors"
          >
            ⌫ Backspace
          </button>
          <button
            onClick={handleClear}
            className="flex-1 bg-gray-700 hover:bg-gray-600 text-white py-2 rounded-md transition-colors"
          >
            Clear
          </button>
        </div>
        
        <button
          onClick={handleSubmit}
          disabled={passwordEmojis.length !== 3}
          className={`w-full py-3 rounded-lg mb-4 transition-colors ${
            passwordEmojis.length === 3
              ? 'bg-blue-600 hover:bg-blue-500 text-white'
              : 'bg-gray-700 text-gray-400 cursor-not-allowed'
          }`}
        >
          Unlock Content
        </button>
        
        {error && <p className="text-red-400 mb-4">{error}</p>}
        
        <div>
          <button
            onClick={() => setShowHint(!showHint)}
            className="text-blue-400 hover:underline text-sm"
          >
            {showHint ? 'Hide Hint' : 'Show Hint'}
          </button>
          {showHint && (
            <p className="text-gray-400 text-sm mt-2">
              Hint: {config.hint}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PasswordProtection; 